const Component = {
  lambdaRunDurationSecondsMax: 13 * 60,
  searchAlgorithms: ["RANDOM", "GENETIC"],

  // Recommended foundWeightsMax per algorithm:
  //   RANDOM  — more samples increase the chance of hitting the global optimum
  //   GENETIC — GA converges quickly; 50 results are enough to surface the best one
  defaultFoundWeightsMax: {
    RANDOM: 200,
    GENETIC: 50,
  },
};

export default Component;
